import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { HelperService } from '../helper.service';

export interface DialogData {
  errorType: string;
  platform: string,
}

@Component({
  selector: 'app-faild-dialog',
  templateUrl: './faild-dialog.component.html',
  styleUrls: ['./faild-dialog.component.scss']
})


export class FaildDialogComponent implements OnInit {
  href = new URL(window.location.href);
  
  constructor(
    private helper: HelperService,
    public dialogRef: MatDialogRef<FaildDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) { }

  ngOnInit() {
  }

  tryAgain(): void {
    this.helper.forceReloadSamePage();
    this.dialogRef.close();
  }

  goToApp() {
    if(this.data.platform == "m"){
      window.open("sadanappkwt://sadankwt.com/");
    }else{
      const url = environment.configs.appHost;//this.href.protocol + "//" + this.href.host + '/home/';
      window.location.href = url;
    }
  }

}
